import type { RouteResources } from '@atlassian/react-resource-router';
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';
import { legacyPortfolioPagesRoute } from '@jira/router-routes__legacy-portfolio-pages-routes/src/legacyPortfolioPagesRoute.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const legacyPortfolioPagesRouteEntry: JiraLegacyRoute<RouteResources> = createLegacyEntry(
	legacyPortfolioPagesRoute,
	() => ({
		layout: globalLayout,

		navigation: {
			menuId: MenuIdPlans,
		},

		entryPoint: () => pageEntryPoint,
	}),
);
